import { useTranslation } from 'react-i18next';

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language;

  const toggle = () => {
    const next = current === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(next);
    localStorage.setItem('lang', next);
  };

  return (
    <button
      onClick={toggle}
      className="text-xs text-muted hover:text-foreground transition-colors px-2 py-1 rounded border border-border hover:border-primary/40"
      title={current === 'zh' ? 'Switch to English' : '切换到中文'}
    >
      {current === 'zh' ? 'EN' : '中'}
    </button>
  );
}
